import { useHeroCardForm } from "@/components/shared/forms/hero-card-form";
import type { HeroCard } from "@stackje/common/config";

interface EditHeroCardProps {
  card: HeroCard;
  cardIndex: number;
}

export function EditHeroCard({ card }: EditHeroCardProps) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } = useHeroCardForm({
    initialData: {
      brandTitle: card.brandTitle || "",
      title: card.title || "",
      description: card.description || "",
      buttonText: card.button?.title || "",
      buttonUrl: card.button?.url || "",
      socialLinks: card.socialLinks || [],
      type: card.type,
      logo: "logo" in card ? card.logo?.src : undefined,
      image: "image" in card ? card.image?.src : undefined,
      backgroundImage: "backgroundImage" in card ? card.backgroundImage?.src : undefined,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    toggleHeroType: toggleType,
    shuffleColors,
    handleSubmit,
  };
}
